import Vue from 'vue'
import VueRouter from 'vue-router'
import routes from './routes'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  routes,
})

// The admin builder is for editing only. Deployed builds are consumer runtimes,
// so block /admin (and its children) and send the user to the front interface.
router.beforeEach((to, from, next) => {
  if (IS_DEPLOYED && to.matched.some((record) => record.name === 'admin')) {
    return next({ name: 'front' })
  }

  next()
})

export default router
